<template>
    <b-card-code title="المجلات العلمية" no-body>
      <b-card-body>
        <div class="d-flex justify-content-between flex-wrap">
          <!-- filter -->
          <b-form-group
            label="فلتر"
            label-cols-sm="1"
            label-align-sm="left"
            label-size="sm"
            label-for="filterInput"
            class="mb-0"
          >
            <b-input-group size="md">
              <b-form-input
                id="filterInput"
                v-model="title"
                type="search"
                placeholder="ابحث عن.."
              />
              <b-input-group-append>
                <b-button @click="resetSearch()"> الغاء الفلتر </b-button>
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  v-b-modal.model-a-w
                >
                  <feather-icon icon="FilePlusIcon" class="mr-50" />
                  <span class="align-middle">اضافة مادة جديدة</span>
                </b-button>
                <export-excel
                style="color: white; padding-top: 10px"
                class="btn btn-default"
                :data="items"
                :fields="exportFields"
                worksheet="My Worksheet"
                name="filename.xls"
              >
                استخراج ملف اكسل
              </export-excel>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </div>
        <b-form-row style="margin-top: 10px">
        <b-col v-show="js.length > 0" md="3">
          <b-form-group>
            <v-select
              v-model="js_id"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="ar_title"
              :options="search.js"
              placeholder="اختر العلمية"
            />
          </b-form-group>
        </b-col>
        <b-col v-show="search.yS.length > 0" md="3">
          <b-form-group>
            <v-select
              v-model="ys_id"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="begin"
              :options="search.yS"
              placeholder="اختر السنة"
            />
          </b-form-group>
        </b-col>
        <b-col v-show="search.iss.length > 0" md="3">
          <b-form-group>
            <v-select
              v-model="is_id"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="title"
              :options="search.iss"
              placeholder="اختر الاصدار"
            />
          </b-form-group>
        </b-col>
      </b-form-row>
      </b-card-body>
  <div class="demo-vertical-spacing">
        <b-progress
        v-if="precentage !== 0"
          :value="precentage"
          max="100"
        />
        </div>
      <b-table
        ref="table"
        striped
        hover
        responsive
        class="position-relative"
        :per-page="perPage"
        :items="items"
        :fields="fields"
      >
        <template #cell(action)="action">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >
            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-col md="12">
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="outline-warning"
                v-b-modal.model-e-w
                @click="eRM(action.item)"
              >
                <feather-icon icon="EditIcon" class="mr-50" />
              </b-button>
            </b-col>
            <b-col  md="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-danger"
              v-b-modal.modal-center
              @click="dRM(action.item)"
            >
              <feather-icon icon="Trash2Icon" class="mr-50" />
            </b-button>
          </b-col>
          </b-dropdown>
        </template>
        
      <template #cell(link)="link">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="outline-info"
          @click="view(link.item.file)"
        >
          <feather-icon icon="FileTextIcon" class="mr-50" />
        </b-button>
      </template>
      <template #cell(logo)="logo">
        <b-avatar size="lg" :src="getImage(logo.item.image)" />
      </template>
      </b-table>
  
      <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
        <!-- page length -->
        <b-form-group
          label="Per Page"
          label-cols="6"
          label-align="left"
          label-size="sm"
          label-for="sortBySelect"
          class="text-nowrap mb-md-0 mr-1"
        >
          <b-form-select
            id="perPageSelect"
            v-model="perPage"
            @change="check()"
            size="sm"
            inline
            :options="pageOptions"
          />
        </b-form-group>
  
        <!-- pagination -->
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          first-number
          last-number
          prev-class="prev-item"
          next-class="next-item"
          class="mb-0"
          @change="check()"
        >
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
      </b-card-body>
      <b-modal
        id="model-e-w"
        ok-title="حفظ التعديلات"
        centered
        size="lg"
        title="تعديل المقالة"
        @ok="uM"
        @hidden="rEF"
      >
      <b-form novalidate class="needs-validation" >
        <b-form-row>
            <b-col v-show="js.length > 0" md="6">
          <b-form-group>
            <v-select
              v-model="editform.journal_id"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="ar_title"
              :options="js"
              placeholder="اختر العلمية"
            />
          </b-form-group>
        </b-col>
        <b-col v-show="yS.length > 0" md="6">
          <b-form-group>
            <v-select
              v-model="editform.year"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="begin"
              :options="yS"
              placeholder="اختر السنة"
            />
          </b-form-group>
        </b-col>
        <b-col v-show="iss.length > 0" md="6">
          <b-form-group>
            <v-select
              v-model="editform.issue_id"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="title"
              :options="iss"
              placeholder="اختر الاصدار"
            />
          </b-form-group>
        </b-col>
            <b-col md="12">
            <label for="input-valid1">العنوان بالعربي :</label>
            <b-form-input
              id="input-valid1"
              v-model="editform.ar_title"
              :state="editform.ar_title.length > 0"
              placeholder="العنوان بالعربي "
            />
          </b-col>
          <b-col md="12">
            <label for="input-valid1">العنوان بالانكليزي :</label>
            <b-form-input
              id="input-valid1"
              v-model="editform.en_title"
              placeholder="العنوان بالانكليزي "
            />
          </b-col>
            <b-col md="12">
            <label for="input-valid1">المؤلفين :</label>
            <b-form-input
              id="input-valid1"
              v-model="editform.authors"
              placeholder="المؤلفين "
            />
          </b-col>
          <b-col md="12">
            <label for="input-valid1">الكلمات المفتاحية:</label>
            <b-form-input
              id="input-valid1"
              v-model="editform.keywords"
              placeholder="الكلمات المفتاحية "
            />
          </b-col>
          <b-col md="12">
            <label for="input-invalid1">التفاصيل بالعربي:</label>
            <b-form-textarea
              id="input-invalid1"
              placeholder="الملخص"
              v-model="editform.abstract"
                rows="3"
            />
          </b-col>
            <b-col md="12">
              <label for="input-valid1">اختر صورة الوصل:</label>
              <b-form-file
              placeholder="اختر الملف او اسقطها هنا..."
              drop-placeholder="اختر الملف او اسقطها هنا..."
                v-model="editform.file"
                @change="selectFileForEditForm"
              />
            </b-col>
        </b-form-row>
      </b-form>
      </b-modal>
      <b-modal
        id="model-a-w"
        ok-title="حفظ البيانات"
        centered
        size="lg"
        title="اضافة مادة جديدة"
        @ok="aNM"
        @hidden="rF"
      >
        <b-form novalidate class="needs-validation" >
          <b-form-row>
            <b-col v-show="js.length > 0" md="6">
          <b-form-group>
            <v-select
              v-model="form.journal_id"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="ar_title"
              :options="js"
              placeholder="اختر العلمية"
            />
          </b-form-group>
        </b-col>
        <b-col v-show="yS.length > 0" md="6">
          <b-form-group>
            <v-select
              v-model="form.year"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="begin"
              :options="yS"
              placeholder="اختر السنة"
            />
          </b-form-group>
        </b-col>
        <b-col v-show="iss.length > 0" md="6">
          <b-form-group>
            <v-select
              v-model="form.issue_id"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              label="title"
              :options="iss"
              placeholder="اختر الاصدار"
            />
          </b-form-group>
        </b-col>
            <b-col md="12">
            <label for="input-valid1">العنوان بالعربي :</label>
            <b-form-input
              id="input-valid1"
              v-model="form.ar_title"
              :state="form.ar_title.length > 0"
              placeholder="العنوان بالعربي "
            />
          </b-col>
          <b-col md="12">
            <label for="input-valid1">العنوان بالانكليزي :</label>
            <b-form-input
              id="input-valid1"
              v-model="form.en_title"
              :state="form.en_title.length > 0"
              placeholder="العنوان بالانكليزي "
            />
          </b-col>
            <b-col md="12">
            <label for="input-valid1">المؤلفين :</label>
            <b-form-input
              id="input-valid1"
              v-model="form.authors"
              :state="form.authors.length > 0"
              placeholder="المؤلفين "
            />
          </b-col>
          <b-col md="12">
            <label for="input-valid1">الكلمات المفتاحية:</label>
            <b-form-input
              id="input-valid1"
              v-model="form.keywords"
              :state="form.keywords.length > 0"
              placeholder="الكلمات المفتاحية "
            />
          </b-col>
          <b-col md="12">
            <label for="input-invalid1">التفاصيل بالعربي:</label>
            <b-form-textarea
              id="input-invalid1"
              placeholder="الملخص"
              v-model="form.abstract"
                rows="3"
            />
          </b-col>
            <b-col md="12">
              <label for="input-valid1">اختر صورة الوصل:</label>
              <b-form-file
              placeholder="اختر الملف او اسقطها هنا..."
              drop-placeholder="اختر الملف او اسقطها هنا..."
                v-model="form.file"
                @change="selectFileForForm"
              />
            </b-col>
                  </b-form-row>
        </b-form>
      </b-modal>
      <b-modal
      id="modal-center"
      centered
      title="حذف مجلة"
      @ok="dM"
      ok-title="Accept"
    >
      <b-card-text>
        هل تريد حذف هذه الحقل ؟
      </b-card-text>
    </b-modal>
    </b-card-code>
  </template>
  
  <script>
  import vSelect from "vue-select";
  import Cleave from "vue-cleave-component";
  import { filesUrl } from "@/main.js";
  import store from "@/store";
  import 'cleave.js/dist/addons/cleave-phone.us'
  import { togglePasswordVisibility } from "@core/mixins/ui/forms";
  import BCardCode from "@core/components/b-card-code/BCardCode.vue";
  import {
    BTable,
    BAvatar,
    BModal,
    BDropdown,
    BDropdownItem,
    BFormCheckboxGroup,
    BForm,
    BFormRow,
    BCol,
    VBModal,
    BBadge,
    BFormValidFeedback,
    BFormInvalidFeedback,
    BFormGroup,
    BFormCheckbox,
    BCardText,
    BFormSelect,
    BPagination,BProgress,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,BFormTextarea,
    BButton,
    BCardBody,BFormFile
  } from "bootstrap-vue";
  import Ripple from "vue-ripple-directive";
  
  export default {
    components: {
      BCardCode,
      BTable,
      BForm,
      vSelect,
      BAvatar,
      BBadge,
      BFormRow,BProgress,BFormTextarea,
      BDropdown,
      Cleave,
      BDropdownItem,
      BFormGroup,
      togglePasswordVisibility,
      BFormSelect,
      BPagination,
      BInputGroup,
      BFormCheckboxGroup,
      BFormInput,
      BInputGroupAppend,
      BButton,
      BCardBody,
      BModal,
      VBModal,
      Ripple,
      BCol,
      BFormCheckbox,
      BCardText,
      BFormValidFeedback,
      BFormInvalidFeedback,BFormFile
    },
    data() {
      return {
        precentage:0,
        teacher_id: "",
        perPage: 5,
        pageOptions: [3, 5, 10, 100,1000],
        totalRows: 1,
        users:[],
        js:[],
        iss:[],
        yS:[],
        js_id:"",
        ys_id:"",
        is:"",
        role: null,
        canDelete: null,
        canEdit: null,
        currentPage: 0,
        category_id: "",
        subtype_id: "",
        type_id: "",
        fromdate:"",
        todate:"",
        carency_id:"",
        carency:[],
        title: "",
        filter: null,
        date: {
            date: true,
            delimiter: '-',
            datePattern: ['Y', 'm', 'd'],
            },
        format:{
          price: {
            numeral: true,
            numeralThousandsGroupStyle: 'thousand',
          },
          number: {
            creditCard: true,
          },
        },
        forwardform:{
          user_id:"",
          instorage_id:"",
          count:"",
          note:"",
          invoise:"",
          date:""
        },
        filterOn: [],
        departments: [],
          categories: [],
          types: [],
          subtypes: [],
        search:{
            js: [],
            iss: [],
          yS: [],
          carency:[]
        },
        fields: [
          {
            key: "en_title",
            label: "العنوان بالانكليزي",
          },
          {
            key: "keywords",
            label: "كلمات مفتاحية",
          },
          {
            key: "authors",
            label: "المؤلفين",
          },
          {
            key: "journal.ar_title",
            label: "المجلة",
          },
          {
            key: "issue.title",
            label: "الاصدار",
          },
          {
            key: "year.begin",
            label: "السنة",
          },
          {
            key: "link",
            label: "الملف",
          },
          { key: "action", label: "الاجراءات" },
        ],
        exportFields:{
            'العنوان': 'en_title',
              'كلمات مفتاحية': 'keywords',
              'المؤلفين': 'authors',
              'المجلة': 'journal.ar_title',
              'الاصدار': 'issue.title',
              'السنة': 'year.begin',
              'الملف': 'file',
        },
        exportData:[
          {
            title: "en_title",
            keywords: "keywords",
            authors: "authors",
            journal: "journal.ar_title",
            issue: "issue.title",
            year: "year.begin",
            link: 'file',
          },
        ],
        items: [],
        form: {
            ar_title: "",
            en_title: "",
            abstract: "",
            year: "",
            authors: "",
            journal_id: "",
            issue_id: "",
            keywords: "",
            file: ""
        },
        editform: {
            ar_title: "",
            en_title: "",
            abstract: "",
            year: "",
            authors: "",
            journal_id: "",
            issue_id: "",
            keywords: "",
            file: "",
            id: null
        },
        selected: [],
        selected2: [],
        options: {
          time: {
            time: true,
            timePattern: ["h", "m"],
          },
        },
      };
    },
    watch: {
      title: function (val) {
        this.gS();
      },
      "form.journal_id": function (val) {
        if (val != null && val != "") {
          this.gSM1();
        }
      },
      "editform.journal_id": function (val) {
        if (val != null && val != "") {
          this.gSM2();
        }
      },
      "form.year": function (val) {
        if (val != null && val != "") {
          this.gSM1();
        }
      },
      "editform.year": function (val) {
        if (val != null && val != "") {
          this.gSM2();
        }
      },
      "js_id": function (val) {
        if (val != null && val != "") {
          this.gSM4();
          this.gS();
        }
      },
      "ys_id": function (val) {
        if (val != null && val != "") {
          this.gSM4();
          this.gS();
        }
      },
      "is": function (val) {
        if (val != null && val != "") {
          this.gS();
        }
      },
      "todate": function (val) {
        if (val != null && val != "") {
          this.gS();
        }
      },
    },
    mixins: [togglePasswordVisibility],
    computed: {
      passwordToggleIcon() {
        return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
      },
    },
    directives: {
      Ripple,
    },
    mounted() {
      this.ID(), this.gS(), this.gSM(), this.gSM3(), this.gU();
    },
    methods: {
        async gSM() {
        await this.axios
          .get(
            `journals?take=1000&skip=0`
          )
          .then((res) => {
            this.js = [];
            this.search.js = [];
            this.js = res.data.items;
            this.search.js = res.data.items;
          })
      },
      async gSM1() {
        let y = ""
        if (isNaN(this.form.journal_id)) {
        this.form.journal_id = this.form.journal_id["id"];
      }
      if (isNaN(this.form.year)) {
        y = this.form.year["id"];
      }
        await this.axios
          .get(
            `issues?take=100&skip=0&journal_id=${this.form.journal_id}&year_id=${y}`
          )
          .then((res) => {
            this.iss = [];
            this.search.iss = [];
            this.iss = res.data.items;
            this.search.iss = res.data.items;
          })
      },
      async gSM2() {
        if (isNaN(this.editform.journal_id)) {
        this.editform.journal_id = this.editform.journal_id["id"];
      }
      
      if (isNaN(this.editform.year)) {
        this.editform.year = this.editform.year["id"];
      }
        await this.axios
          .get(
            `issues?take=100&skip=0&journal_id=${this.editform.journal_id}&year_id=${this.editform.year}`
          )
          .then((res) => {
            this.iss = [];
            this.search.iss = [];
            this.iss = res.data.items;
            this.search.iss = res.data.items;
          })
      },async gSM3() {
        await this.axios
          .get(
            `years`
          )
          .then((res) => {
            this.yS = [];
            this.search.yS = [];
            this.yS = res.data.items;
            this.search.yS = res.data.items;
          })
      },
      async gSM4() {
        if (isNaN(this.js_id)) {
        this.js_id = this.js_id["id"];
      }
      
      if (isNaN(this.ys_id)) {
        this.ys_id = this.ys_id["id"];
      }
        await this.axios
          .get(
            `issues?take=100&skip=0&journal_id=${this.js_id}&year_id=${this.ys_id}`
          )
          .then((res) => {
            this.search.iss = [];
            this.search.iss = res.data.items;
          })
      },
      async gU() {
        await this.axios
          .get(`users-name`)
          .then((res) => {
            this.users = [];
            this.users = res.data.items;
          })
          .catch((e) => {
            if (e.message.includes("401")) {
              this.makeToast(
                "danger",
                "update failed",
                "you don't a permision to do this action ;)"
              );
            } else {
              this.errorToast();
            }
          });
      },
      async uM() {
        if (isNaN(this.editform.journal_id)) {
        this.editform.journal_id = this.editform.journal_id["id"];
      }
      if (isNaN(this.editform.year)) {
        this.editform.year = this.editform.year["id"];
      }
      
      if (isNaN(this.editform.issue_id)) {
        this.editform.issue_id = this.editform.issue_id["id"];
      }
        let data = new FormData();
        data.append("ar_title", this.editform.ar_title);
        data.append("en_title", this.editform.en_title);
        data.append("year", this.editform.year);
        data.append("authors", this.editform.authors);
        data.append("abstract", this.editform.abstract);
        data.append("journal_id", this.editform.journal_id);
        data.append("issue_id", this.editform.issue_id);
        data.append("keywords", this.editform.keywords);
        data.append("file", this.editform.file);
        await this.axios
          .post(`articles/${this.editform.id}`, data,{
            onUploadProgress: progressEvent => {
              this.precentage =
                (progressEvent.loaded / progressEvent.total) * 100;
            }
          })
          .then((res) => {
              this.gS();
            if (res.data.errors) {
              this.errorToast();
            } else {
              this.makeToast(
                "success",
                "update Success",
                "Your update is done successfully"
              );
            }
            this.precentage=0
          })
          .catch((e) => {
            if (e.message.includes("401")) {
              this.makeToast(
                "warning",
                "update failed",
                "you don't a permision to do this action ;)"
              );
            } else {
              this.errorToast();
            }
          });
          this.rEF()
      },
      async aNM() {
        if (isNaN(this.form.journal_id)) {
        this.form.journal_id = this.form.journal_id["id"];
      }
      if (isNaN(this.form.year)) {
        this.form.year = this.form.year["id"];
      }
      if (isNaN(this.form.issue_id)) {
        this.form.issue_id = this.form.issue_id["id"];
      }
        let data = new FormData();
        data.append("ar_title", this.form.ar_title);
        data.append("en_title", this.form.en_title);
        data.append("year", this.form.year);
        data.append("authors", this.form.authors);
        data.append("abstract", this.form.abstract);
        data.append("journal_id", this.form.journal_id);
        data.append("issue_id", this.form.issue_id);
        data.append("keywords", this.form.keywords);
        data.append("file", this.form.file);
        await this.axios
          .post(`articles`, data,{
            onUploadProgress: progressEvent => {
              this.precentage =
                (progressEvent.loaded / progressEvent.total) * 100;
            }
          })
          .then((res) => {
              this.gS();
            if (res.data.errors) {
              this.errorToast();
            } else {
              this.makeToast(
                "success",
                "update Success",
                "Your model is added successfully"
              );
            }
            this.rF();
            this.precentage=0
          })
          .catch((e) => {
            if (e.message.includes("401")) {
              this.makeToast(
                "warning",
                "update failed",
                "you don't a permision to do this action ;)"
              );
            } else {
              this.errorToast();
            }
          });
        this.rF();
      },
     
      rF() {
        this.form.ar_title = ""
        this.form.en_title = ""
        this.form.abstract = ""
        this.form.year = ""
        this.form.authors = ""
        this.form.journal_id = ""
        this.form.issue_id = ""
        this.form.keywords = ""
        this.form.file = ""
      },
      rEF() {
        this.editform.ar_title = ""
        this.editform.en_title = ""
        this.editform.abstract = ""
        this.editform.year = ""
        this.editform.authors = ""
        this.editform.journal_id = ""
        this.editform.issue_id = ""
        this.editform.keywords = ""
        this.editform.file = ""
        this.editform.id = "";
      },
      async dM() {
        await this.axios
          .delete(`articles/${this.editform.id}`)
          .then((res) => {
            if (res.data.errors) {
              this.errorToast();
            } else {
              this.gS();
              this.makeToast(
                "success",
                "Delete Success",
                "Your item is deleted successfully"
              );
            }
          })
          .catch((e) => {
            if (e.message.includes("401")) {
              this.makeToast(
                "warning",
                "update failed",
                "you don't a permision to do this action ;)"
              );
            } else {
              this.errorToast();
            }
          });
      },
      errorToast() {
        this.makeToast(
          "danger",
          "update failed",
          "some thing want wrong, i`m sorry :("
        );
      },
      eRM(item) {
        this.editform.ar_title = item.ar_title;
        this.editform.en_title = item.en_title;
        this.editform.abstract = item.abstract;
        this.editform.year = item.year_id;
        this.editform.authors = item.authors;
        this.editform.journal_id = item.journal_id;
        this.editform.issue_id = item.issue_id;
        this.editform.keywords = item.keywords;
        this.editform.file = item.image;
        this.editform.id = item.id;
      },
      dRM(item) {
        this.editform.title = item.title;
        this.editform.id = item.id;
      },
      check() {
        setTimeout(() => this.gS(), 1000);
      },
      ID() {
        this.teacher_id = localStorage.getItem("NisourTeacherId");
      },
      async gS() {
        if (isNaN(this.js_id)) {
        this.js_id = this.js_id["id"];
      }
      if (isNaN(this.ys_id)) {
        this.ys_id = this.ys_id["id"];
      }
      if (isNaN(this.is)) {
        this.is = this.is["id"];
      }
        await this.axios
          .get(
            `articles?take=${this.perPage}&skip=${this.currentPage - 1}&title=${
              this.title
            }&journal_id=${this.js_id}&issue_id=${this.is}&year_id=${this.ys_id}` 
          )
          .then((res) => {
            this.items = [];
            this.totalRows = res.data.totalCount;
            this.items = res.data.items;
          })
          .catch((e) => {
            if (e.message.includes("401")) {
              this.makeToast(
                "danger",
                "update failed",
                "you don't a permision to do this action ;)"
              );
            } else {
              this.errorToast();
            }
          });
      },
      makeToast(variant = null, title = null, body = null) {
        this.$bvToast.toast(body, {
          title: title,
          variant,
          solid: false,
        });
      },
      resetSearch() {
        this.title = "",
        this.js_id = "",
        this.ys_id= "",
        this.is= "",
        this.gS();
      },
      selectFileForForm(e) {
        this.form.file = "";
        console.log(e.target.files);
        console.log(e.target.files[0]);
        this.form.file = e.target.files[0];
        console.log(this.form.files);
      },
      selectFileForEditForm(e) {
        this.editform.file = "";
        console.log(e.target.files);
        console.log(e.target.files[0]);
        this.editform.file = e.target.files[0];
        console.log(this.editform.file);
      },
      onClicked(path) {
        console.log(path)
        window.open(`${filesUrl}/${path}`, "_blank");
      },
      getImage(path) {
      return `${filesUrl}/${path}`;
    },
    view(path) {
      window.open(`${filesUrl}/${path}`, "_blank");
    },
    text(item){
      return item.title
    }
    },
  };
  </script>
  